"use strict";
/**
 * @file Created on 24.07.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NWindowWrapperConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NWindowWrapperConverter, _NotificationDocConve);

  function NWindowWrapperConverter() {
    _classCallCheck(this, NWindowWrapperConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NWindowWrapperConverter).apply(this, arguments));
  }

  return NWindowWrapperConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NWindowWrapperConverter = NWindowWrapperConverter;